import {
  apiHost,
  generatelink,
  getClickedLinksByUser,
  getWallet,
} from '@utils/constants';
import useRequest from '@utils/useRequest';

const getGeneratedLinkService = () => {
  return new Promise((resolve, reject) => {
    useRequest({
      url: `${apiHost}${generatelink}`,
      useSession: true,
      method: 'get',
    })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};

const getClickedLinksService = () => {
  return new Promise((resolve, reject) => {
    useRequest({
      url: `${apiHost}${getClickedLinksByUser}`,
      useSession: true,
      method: 'get',
    })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};

const getWalletService = ({ params }) => {
  return new Promise((resolve, reject) => {
    useRequest({
      url: `${apiHost}${getWallet}`,
      useSession: true,
      method: 'get',
      params,
    })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export { getGeneratedLinkService, getClickedLinksService, getWalletService };
